import { combineReducers } from '@reduxjs/toolkit';
import { persistReducer } from 'redux-persist';
import { getPersistConfig } from 'redux-deep-persist';
import storage from 'redux-persist/lib/storage';

import userReducer from './user';
import edfReducer from './edf/index';
import chartReducer from './chart';

const reducers = combineReducers({
    edf: edfReducer,
    user: userReducer,
    chart: persistReducer(
        getPersistConfig({
            key: 'channelsConfig',
            version: 1,
            storage,
            whitelist: ['channelsConfig'],
            rootReducer: chartReducer,
        }),
        chartReducer
    ),
});

export default reducers;
